import {KPICard} from "@/components/KPICard/KPICard.tsx";
import {DurationFormatOptions, durationSecFn} from "@/lib/format.tsx";

interface StatHeaderCheckFrequencyProps {
  interval: number;
}

export const StatHeaderCheckFrequency = ({interval}: StatHeaderCheckFrequencyProps) => {
  return <KPICard title="Check Frequency">Every {durationSecFn(interval * 60, DurationFormatOptions.LONG)}</KPICard>;
};
